var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"image-viewer"}},[(_vm.getSrc)?_c('img',{attrs:{"src":_vm.getSrc}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }